import { render } from "./NewPlant.vue?vue&type=template&id=53a60b02&ts=true"
import script from "./NewPlant.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewPlant.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/plant/NewPlant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53a60b02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53a60b02', __exports__)) {
    api.reload('53a60b02', __exports__)
  }
  
  module.hot.accept("./NewPlant.vue?vue&type=template&id=53a60b02&ts=true", () => {
    api.rerender('53a60b02', render)
  })

}


export default __exports__